import { Badge } from '@si-armes/dsfr-react';
import React from 'react';
import moment from 'moment';
import {
    CODES_POSTAUX_GUYANE_AUTORISES,
    CODES_POSTAUX_MAYOTTE_AUTORISES,
} from '../constants/contraintes.constants';
import { MESSAGE_DATE_NAISSANCE_INVALIDE } from '../constants/messagePersonalise.constants';
import {
    LIBELLE_A_CORRIGER,
    LIBELLE_A_REGULARISER,
    LIBELLE_DETENUE,
    LIBELLE_VALIDER_ACQUISITION,
    LIBELLE_EXPEDITION_EN_COURS,
} from '../components/arme/statuts/StatutsArmes';

/**
 * Permet de générer le message d'erreur à partir du champ manquant
 * @param libelleChamp
 * @returns string message
 */
// eslint-disable-next-line import/prefer-default-export
export const getMessageErreurChampManquant = (libelleChamp) => {
    return `Le champ "${libelleChamp}" est obligatoire.`;
};

export const getMessageErreurChampIncorrect = (libelleChamp) => {
    return `Le champ "${libelleChamp}" n'est pas correcte.`;
};

export const checkPrenom = (args) => {
    return args.filter((e) => !e || e === '').length > 0;
};

export const formattingMaxInput = (length) => (value) => {
    return value.slice(0, length);
};

export const getPatternHookFormValidation = (regex, libelleChamp, messagePersonnalise = null) => {
    if (messagePersonnalise) {
        return {
            value: regex,
            message: messagePersonnalise,
        };
    }

    return {
        value: regex,
        message: `Le champ "${libelleChamp}" possède des caractères interdits.`,
    };
};

export const getValueIsNotNull = (value) => {
    if (value) {
        return value;
    }
    return null;
};

export const validateDateNaissance = (valueDateNaissance) => {
    const dateNaissanceSplit = valueDateNaissance.split('/');
    if (
        dateNaissanceSplit &&
        dateNaissanceSplit.length === 3 &&
        dateNaissanceSplit[2] >= moment().format('YYYY')
    ) {
        return MESSAGE_DATE_NAISSANCE_INVALIDE;
    }
    return null;
};

export const validateDepartement = (valueDepartement, paysNaissance) => {
    if (!valueDepartement && paysNaissance === '75') {
        return getMessageErreurChampManquant('département de Naissance');
    }
    return null;
};

/* Bloquer temporairement certains codes postaux de Guyane, Mayotte et Nouvelle-Calédonie
Seuls les codes explicitement autorises (SIAR-6256, SIAR-6257) sont acceptes */
export const verifierSiDepartementEstOuvertALaCreationDeCompte = (event) => {
    if (!event) {
        return null;
    }

    // Verifier si le code postal est dans les listes autorisees
    const isGuyaneAutorise = CODES_POSTAUX_GUYANE_AUTORISES.includes(event);
    const isMayotteAutorise = CODES_POSTAUX_MAYOTTE_AUTORISES.includes(event);

    // Si autorise, on ne bloque pas
    if (isGuyaneAutorise || isMayotteAutorise) {
        return null;
    }

    // Bloquer les codes postaux de 5 chiffres commençant par 973, 976, 987, 988 non autorises
    const estDepartementBloque = /^(973|976|987|988)[0-9]{2}$/.test(event);

    if (estDepartementBloque) {
        return "L'espace détenteur n'est pas encore ouvert aux chasseurs dans votre région";
    }

    return null;
};

// Renvoie TRUE si date1 est plus récente que date2
export const comparerDeuxDates = (date1, date2) => {
    const date1Formatee = date1.split('/');
    const date2Formatee = date2.split('/');

    if (parseInt(date1Formatee[2], 10) > parseInt(date2Formatee[2], 10)) {
        return true;
    }
    if (parseInt(date1Formatee[2], 10) === parseInt(date2Formatee[2], 10)) {
        if (parseInt(date1Formatee[1], 10) > parseInt(date2Formatee[1], 10)) {
            return true;
        }
        if (parseInt(date1Formatee[1], 10) === parseInt(date2Formatee[1], 10)) {
            if (parseInt(date1Formatee[0], 10) > parseInt(date2Formatee[0], 10)) {
                return true;
            }
        }
    }
    return false;
};

export const formaterOptions = (options, allowEmpty = false) => {
    return options.map((option, index) => {
        const value = allowEmpty ? option.value : option.value || (index + 1).toString();
        return {
            name: option.libelle || option.key,
            value,
        };
    });
};

export const displayStatut = (statut) => {
    const mapping = {
        [LIBELLE_A_REGULARISER]: 'info',
        [LIBELLE_VALIDER_ACQUISITION]: 'info',
        [LIBELLE_DETENUE]: 'success',
        [LIBELLE_A_CORRIGER]: 'warning',
        [LIBELLE_EXPEDITION_EN_COURS]: 'info',
    };

    return statut ? <Badge label={statut} size="md" system={mapping[statut]} /> : <></>;
};

export const displayStatutImportEnMasse = ({ label, system }) => {
    return system ? <Badge label={label} size="md" system={system} /> : <></>;
};

export const formaterDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR');
};

export const telechargerFichierDepuisContenu = (contenu, titreFichier) => {
    const arrayOctets = atob(contenu);
    const arrayBuffer = new Uint8Array(arrayOctets.length);

    for (let i = 0; i < arrayOctets.length; i += 1) {
        arrayBuffer[i] = arrayOctets.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
    const downloadLink = document.createElement('a');

    downloadLink.download = titreFichier;
    downloadLink.href = URL.createObjectURL(blob);
    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(downloadLink);
};

export const CLEAR_INFORMATIONS = 'CLEAR_INFORMATIONS';
export const CLEAR_ALERTES = 'CLEAR_ALERTES';
